import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { HelpLauncher } from "@/components/HelpCenter/HelpLauncher";

import { ListTable } from "../../components/ListTable";

export const ListOverview: FunctionComponent = () => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.${key}`);

	return (
		<div className="sm:block flex flex-col items-start justify-between">
			<div className="flex items-center gap-2.5 h-12 py-2 px-4 bg-white border-b border-border-light w-full">
				<span className="text-sm font-semibold text-text whitespace-nowrap">{ts("title")}</span>

				<div className="ml-auto flex items-center gap-2">
					<HelpLauncher />
				</div>
			</div>

			{<ListTable />}
		</div>
	);
};
